export default __webpack_public_path__ + "static/media/cafeina-bg.3636465f.jpg";